import { render } from "./logo-pln-token.svg?vue&type=template&id=43859ff6"
const script = {}
script.render = render

export default script